import React, { useEffect } from 'react';
import MenuProps from './Menu.types';
import MenuWrapper from './Menu.style';

const Menu = (props: MenuProps) => {
  const {
    children,
    show = false,
    close = () => {},
    className
  } = props;

  useEffect(() => {
    const body = document.querySelector('body');

    if (show) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = 'auto';
    }

    return () => {
      body.style.overflow = 'auto';
    };
  }, [show]);

  function handleModalWrapperClick() {
    close();
  }

  function handleModalInnerClick(event) {
    event.stopPropagation();
  }

  return (
    <MenuWrapper
      isOpen={show}
      onClick={handleModalWrapperClick}
      role="dialog"
      className={`Modal ${className ? className : ''}`}
    >
      <div className="Modal-inner" onClick={handleModalInnerClick} role="document">
        <div className="Modal-body">{children}</div>
      </div>
    </MenuWrapper>
  );
};

export default Menu;
